import { useImmobilierSearchStore } from '../stores/immobilierSearchStore.js'

export function useImmobilierSearch() {
  const status = useImmobilierSearchStore((s) => s.status)
  const error = useImmobilierSearchStore((s) => s.error)
  const annonces = useImmobilierSearchStore((s) => s.annonces)
  const total = useImmobilierSearchStore((s) => s.total)
  const searchId = useImmobilierSearchStore((s) => s.searchId)
  const pollCount = useImmobilierSearchStore((s) => s.pollCount)
  const refreshing = useImmobilierSearchStore((s) => s.refreshing)
  const search = useImmobilierSearchStore((s) => s.startSearch)
  const reset = useImmobilierSearchStore((s) => s.reset)
  const refreshAnnonces = useImmobilierSearchStore((s) => s.refreshAnnonces)

  const loading = status === 'scraping' || status === 'polling' || status === 'fetching'
  const done = status === 'done'

  return { status, loading, done, error, annonces, total, searchId, pollCount, refreshing, search, reset, refreshAnnonces }
}
